import React from 'react';
import { ReadOnlyField, Theme } from '@indigo-ag/component-module';

import { createStylesHook } from '../../hooks/createStylesHook';

interface StyleProps {
  columns: number;
}

const useStyles = createStylesHook<Theme, StyleProps>((theme: Theme) => ({
  gridContainer: props => ({
    display: 'grid',
    gridTemplateColumns: Array(props.columns)
      .fill('1fr')
      .join(' '),
    columnGap: theme.spacing(1),
    rowGap: `${theme.spacing(1)}px` // ? theme.spacing(1) directly not working - only applying string
  })
}));

export interface GridContainerItem {
  label?: string;
  value?: string;
  customField?: React.ReactNode;
}

export interface GridContainerProps extends StyleProps {
  items?: GridContainerItem[];
  classes?: {
    container?: string;
  };
}

export const GridContainer: React.FunctionComponent<GridContainerProps> = ({
  columns,
  items = [],
  classes,
  children
}) => {
  /**
   * Styles
   */
  const innerClasses = useStyles({ columns });

  return (
    <div className={`${innerClasses.gridContainer} ${classes?.container || ''}`}>
      {children
        ? children
        : items.map((i, idx) => {
            return (
              <div key={`gridContainerItem-${idx}`}>
                {i.customField ? i.customField : <ReadOnlyField label={i.label || ''} value={i.value || '-'} />}
              </div>
            );
          })}
    </div>
  );
};
